module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 21@2x.0d048055.png";